export default __webpack_public_path__ + "56a264d0ecc6e308de31673c9476cb4f.webp";